import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { api } from "src/environments/environment";
import { PageResponse } from "../interfaces/page-response.interface";
import { ProyectoDepurar } from "../interfaces/proyecto-depurar.interface";
import { Todo } from "../interfaces/todo.interface";

@Injectable({
    providedIn: 'root'
})
export class BandejaService {

    URL = `${api.urlAPI}` + 'api/bandeja/';
    PROYECTOS_URL = `${api.urlAPI}` + 'api/reportes/overRetention';

    constructor(private http: HttpClient) { }

    getBandejaSolicitud(designado: string, estatus: string, page: number, size: number): Observable<Todo[]> {
        return this.http.get<Todo[]>(this.URL + 'list/consulta/solicitud/' + designado + '/estatus/' + estatus + '/page/' + page + '/size/' + size);
    }

    getBandejaProyecto(usuario: string, estatus: string, page: number, size: number): Observable<Todo[]> {
        return this.http.get<Todo[]>(this.URL + 'list/consulta/proyecto/' + usuario + '/estatus/' + estatus + '/page/' + page + '/size/' + size);
    }

    getCountProyectos(user: string, estatus: string) {
        return this.http.get(this.URL + 'count/proyect/' + user + '/estatus/' + estatus);
    }

    getCountSolicitudes(user: string, estatus: string) {
        return this.http.get(this.URL + 'count/request/' + user + '/estatus/' + estatus);
    }

    getBandejaProyectoAdmin(query: string, pais: string, page: number, size: number): Observable<Todo[]> {
        return this.http.get<Todo[]>(this.URL + 'list/consulta/proyecto/' + query + '/pais/' + pais + '/page/' + page + '/size/' + size);
    }

    getBandejaProyectoUsuarioM(query: string, numReg: string, page: number, size: number): Observable<Todo[]> {
        return this.http.get<Todo[]>(this.URL + 'list/consulta/proyecto/' + query + '/usuarioM/' + numReg + '/page/' + page + '/size/' + size);
    }

    getBandejaProyectoAdminEstatus(pais: string, estatus: string, page: number, size: number): Observable<Todo[]> {
        return this.http.get<Todo[]>(this.URL + 'list/consulta/proyectoPais/' + pais + '/estatus/' + estatus + '/page/' + page + '/size/' + size);
    }

    getBandejaSolicitudUsuarioM(query: string, numReg: string, page: number, size: number): Observable<Todo[]> {
        return this.http.get<Todo[]>(this.URL + 'list/consulta/solicitud/' + query + '/usuarioM/' + numReg + '/page/' + page + '/size/' + size);
    }

    getSolicitudesDepurar(
        page: number,
        size: number,
        years: number = 8,
        fechaInicio?: string,
        fechaFin?: string,
        nomProyecto?: string,
        folio?: string
    ): Observable<PageResponse<ProyectoDepurar>> {
        let params = new HttpParams()
            .set('years', years.toString())
            .set('page', page.toString())
            .set('size', size.toString());

        if (fechaInicio) {
            params = params.set('fechaInicio', fechaInicio);
        }

        if (fechaFin) {
            params = params.set('fechaFin', fechaFin);
        }

        if (nomProyecto && nomProyecto.trim()) {
            params = params.set('nomProyecto', nomProyecto.trim());
        }

        if (folio && folio.trim()) {
            params = params.set('folio', folio.trim());
        }

        return this.http.get<PageResponse<any>>(this.PROYECTOS_URL, { params }).pipe(
            map((response: PageResponse<any>) => ({
                ...response,
                content: (response.content || []).map((item: any) => this.normalizarProyectoDepurar(item))
            }))
        );
    }

    actualizarRetencionProyecto(proyecto: ProyectoDepurar): Observable<ProyectoDepurar> {
        const payload = {
            cveProyecto: proyecto.cveProyecto,
            retencion: proyecto.retencion,
            motivoRetencion: proyecto.motivoRetencion
        };

        return this.http.put<any>(this.PROYECTOS_URL, payload).pipe(
            map((response: any) => this.normalizarProyectoDepurar(response || payload))
        );
    }

    private normalizarProyectoDepurar(item: any): ProyectoDepurar {
        return {
            ...item,
            folio: item.folio ?? item.nombreCreador ?? '',
            fechaDepuracion: this.normalizarFecha(item.fechaDepuracion ?? item.fechaDepurion),
            fechaUltMod: this.normalizarFecha(item.fechaUltMod) || ''
        };
    }

    private normalizarFecha(valor: any): string | undefined {
        if (!valor) {
            return undefined;
        }

        if (Array.isArray(valor)) {
            const [year, month, day, hour = 0, minute = 0, second = 0] = valor;
            const fecha = new Date(year, month - 1, day, hour, minute, second);
            return isNaN(fecha.getTime()) ? undefined : fecha.toISOString();
        }

        if (typeof valor === 'string') {
            return valor.includes('T') ? valor : valor.replace(' ', 'T');
        }

        if (valor instanceof Date) {
            return isNaN(valor.getTime()) ? undefined : valor.toISOString();
        }

        return undefined;
    }

}